// extracted by mini-css-extract-plugin
export default {"Prescription":"Container_Prescription__ySuhx","Red":"Container_Red__vbU8+"};